import React, {useEffect} from 'react'
import SwaggerEditor from 'swagger-editor'
import 'swagger-editor/dist/swagger-editor.css'
import '../../../../stylesheet/swagger-editor.css'

const OASEditor = (
  {
    domId = '#swagger-editor',
    contract = {definition: ''},
    style = {}
  }
) => {
  const isJson = (input) => {
    return input.indexOf('{') === 0
  }

  const formatDefinition = (input) => {
    if (isJson(input)) {
      try {
        return JSON.stringify(JSON.parse(input), null, 2)
      } catch {

      }
    }
    return input
  }

  useEffect(() => {
    window.localStorage.setItem('swagger-editor-content', formatDefinition(contract.definition))
    window.oas_editor = SwaggerEditor({
      dom_id: domId,
      layout: 'EditorLayout',
      plugins: [],
      swagger2GeneratorUrl: 'https://generator.swagger.io/api/swagger.json',
      oas3GeneratorUrl: 'https://generator3.swagger.io/openapi.json',
      swagger2ConverterUrl: 'https://converter.swagger.io/api/convert',
    })
  }, [domId, contract])

  return (
    <div id={domId.replace('#', '')} style={style} data-testid='oas-editor'/>
  )
}

export {OASEditor}

export default OASEditor